import React from 'react';
import { motion } from 'framer-motion';
import { CodeBracketIcon, ChartBarIcon, RocketLaunchIcon, BriefcaseIcon } from '@heroicons/react/24/outline';

const InvSlide15Team: React.FC = () => {
  const team = [
    {
      name: 'Alex',
      role: 'Technical Founder',
      background: [
        'Founder, Chemist2U (250K customers)',
        'Previously: MyDoctor',
        'Full-stack development',
        'AI/ML integration expertise',
      ],
      icon: CodeBracketIcon,
      color: '#0ea5e9',
    },
    {
      name: 'Tim Van Brugge',
      role: 'Business & Marketing',
      background: [
        'Co-founder, Chemist2U',
        'Previously: MyDoctor',
        'Web and startup experience',
        'Go-to-market strategy',
      ],
      icon: ChartBarIcon,
      color: '#10b981',
    },
    {
      name: 'Blair Hamilford',
      role: 'Strategy & Operations',
      background: [
        'Founder/Investor Lumen8',
        'Business and Sales strategy expertise',
        'Media and technology sector experience',
        'Operations leadership',
      ],
      icon: BriefcaseIcon,
      color: '#8b5cf6',
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-3 text-center"
      >
        The Team
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl text-[#94a3b8] mb-12 text-center"
      >
        Experienced founders with a track record of building and scaling products
      </motion.p>

      <div className="flex gap-6 max-w-6xl mb-10">
        {team.map((member, index) => (
          <motion.div
            key={member.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 + index * 0.15 }}
            className="flex-1"
          >
            <div
              className="p-6 rounded-2xl h-full"
              style={{
                background: `${member.color}10`,
                border: `2px solid ${member.color}40`,
              }}
            >
              <div className="flex items-center gap-4 mb-6">
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center"
                  style={{
                    background: `${member.color}20`,
                    border: `2px solid ${member.color}`,
                  }}
                >
                  <member.icon className="w-8 h-8" style={{ color: member.color }} />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white">{member.name}</h3>
                  <p style={{ color: member.color }} className="font-medium">
                    {member.role}
                  </p>
                </div>
              </div>

              <div className="space-y-3">
                {member.background.map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div
                      className="w-2 h-2 rounded-full"
                      style={{ background: member.color }}
                    />
                    <span className="text-[#94a3b8]">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* ChemistU Reference */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.85 }}
        className="max-w-3xl"
      >
        <div
          className="p-6 rounded-xl text-center"
          style={{
            background: 'rgba(30, 41, 59, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <div className="flex items-center justify-center gap-3 mb-3">
            <RocketLaunchIcon className="w-6 h-6 text-[#f59e0b]" />
            <h4 className="text-xl font-semibold text-white">Proven Track Record</h4>
          </div>
          <p className="text-[#94a3b8]">
            Built and scaled <span className="text-white font-medium">Chemist2U</span> to 250,000+ customers.
            Experience in healthcare tech, logistics, and consumer platforms.
            Deep understanding of scalable infrastructure and cost optimization.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default InvSlide15Team;
